import { Link } from 'react-router-dom'
import { formatDate } from 'utils/dateUtils'
import { PaymentMethodDto } from '../../../generated-api'

type PaymentMethodListProps = {
    paymentMethods: PaymentMethodDto[]
}
const PaymentMethodList = (props: PaymentMethodListProps) => {
    const { paymentMethods } = props

    return (
        <div className="rounded-lg bg-brand-white shadow-lg py-4 mt-4">
            <div className="overflow-x-auto">
                <div className="min-w-full inline-block">
                    <div className="overflow-hidden">
                        <table className="text-left min-w-full">
                            <thead className="text-grey-dark">
                                <tr>
                                    <th scope="col" className="font-normal py-2 px-5 whitespace-nowrap">
                                        Id
                                    </th>
                                    <th scope="col" className="font-normal py-2 px-5 whitespace-nowrap">
                                        Payment provider
                                    </th>
                                    <th scope="col" className="font-normal py-2 px-5 whitespace-nowrap">
                                        Payment method
                                    </th>
                                    <th scope="col" className="font-normal py-2 px-5 whitespace-nowrap">
                                        Created
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {paymentMethods.map((paymentMethod, index) => (
                                    <tr key={index} className="hover:bg-purple-lightest border-t border-grey-lightest">
                                        <td className="py-4 px-5 whitespace-nowrap text-sm">
                                            <Link
                                                to={`${paymentMethod.paymentProvider}/${paymentMethod.paymentMethod}`}
                                                className="py-4 cursor-pointer text-brand-primary"
                                            >
                                                {paymentMethod.externalId}
                                            </Link>
                                        </td>
                                        <td className="py-4 px-5 whitespace-nowrap text-sm">
                                            {paymentMethod.paymentProvider}
                                        </td>
                                        <td className="py-4 px-5 whitespace-nowrap text-sm">
                                            {paymentMethod.paymentMethod}
                                        </td>
                                        <td className="py-4 px-5 whitespace-nowrap text-sm">
                                            {formatDate(paymentMethod.created)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentMethodList
